module.exports = __webpack_public_path__ + "fonts/humidity.svg?v=b89c00a03fb83b5e7cb8b05c2e9afa1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/humidity.svg
// module id = 691
// module chunks = 0